import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify';
import { sync } from 'vuex-router-sync'
// eslint-disable-next-line
const unsync = sync(store, router); // done. Returns an unsync callback fn
import axios from 'axios'
import moment from 'moment-mini'
import swal from 'sweetalert2'

Vue.config.productionTip = false

Vue.prototype.$moment = moment;
Vue.prototype.$http = axios.create({
  baseURL: process.env.VUE_APP_API_URL
});
Vue.prototype.$http.interceptors.request.use(
  (config) => {
    if(store.state.access_token) config.headers['Authorization'] = 'Bearer ' + store.state.access_token;
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
)
Vue.prototype.$http.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if(error.response.status == 401 && !store.state.route.fullPath.match(/^\/auth(\/.*)?$/)) {
      store.dispatch('logoutUser', true);
    }
    return Promise.reject(error);
  }
)

Vue.prototype.$swal = swal.mixin({
  showConfirmButton: true,
  showCancelButton: true,
  reverseButtons: true,
  animation: false,
  confirmButtonColor: '#3399CC',
  scrollbarPadding: false
})

//Redirect for non auth pages
router.beforeEach((to, from, next) => {
  const noAuthRequired = to.matched.some((route) => route.meta.noauth);
  const authed = store.getters.isAuthorized;

  if(!noAuthRequired && !authed) {
    let redir = {
      path: '/auth'
    }
    if(to.fullPath != '/') redir.query = { redirect: to.fullPath };
    next(redir);
  } else if(noAuthRequired && authed) {
    next({path: '/'});
  } else {
    next();
  }
})

Vue.filter('filesize', bytes => {
  let divider = 1000;
  let size = bytes / divider;
  if(size < 1000) {
    return Math.round(size) + ' KB';
  }
  size = size / divider;
  if(size < 1000) {
    return size.toFixed(2) + ' MB';
  }
  size = size / divider;
  return size.toFixed(2) + ' GB';
});

new Vue({
  router,
  store,
  vuetify,
  beforeCreate() {
    store.commit('resetCaches');
    store.dispatch('checkForUpdates', true);
  },
  mounted() {
    let ref = this;
    window.addEventListener('focus', function() { ref.docFocused(); });
  },
  computed: {
    cdn: function() {
      return process.env.VUE_APP_CDN_URL;
    }
  },
  methods: {
    docFocused() {
      store.dispatch('checkForUpdates');
    }
  },
  render: h => h(App)
}).$mount('#app')
